import {
  CorrespondenceMethodEnum,
  CountryCodeEnum,
  NoYesEnum,
  TelephoneTypeEnum,
  TitleEnum,
} from '../../../types/forms';

/**
 * @deprecated - Please use version from /types/forms.ts
 * - Feel free to replace usage of this enum with the new one.
 */
export enum MaritalStatusEnum {
  married = 'married',
  single = 'single',
  coHabiting = 'coHabiting',
  divorced = 'divorced',
  separated = 'separated',
  widowed = 'widowed',
  widower = 'widower',
}

/**
 * @deprecated - use types from `types` directory instead.
 */
export enum GenderEnum {
  male = 'male',
  female = 'female',
}

/**
 * @deprecated - use types from `types` directory instead.
 */
export enum CcrTypeEnum {
  /**
   * Personal Public Service (PPS) Number
   */
  ppsn = 'PPSN',
  itnNonRoi = 'Individual Tax Number (non ROI)',
}

export type CustomerDetailsFormModel_MX = {
  gender?: GenderEnum;
  title?: TitleEnum;
  maritalStatus?: MaritalStatusEnum | null;
  makeIndemnifier?: NoYesEnum | null;
  firstName?: string;
  lastName?: string;
  middleName?: string | null;
  maidenName?: string;
  dateOfBirth?: string;
  email?: string;
  telephoneType?: TelephoneTypeEnum | null;
  phoneNumber?: string;
  countryCode?: CountryCodeEnum;
  correspondenceMethod?: CorrespondenceMethodEnum | null;
  ccrType?: CcrTypeEnum | null;
  ccrId?: string | null;
};
